module.exports = __webpack_public_path__ + "static/media/centivo-logo-new.b8ae1d98.svg";